export default __webpack_public_path__ + "daf11cc06ae9bc3858745943d5fc7018.png";